import { MenuItem } from 'primeng/api';
import { UntypedFormGroup } from '@angular/forms';

export class BaseForm {

  public inEdit = false;
  public loading = false;
  public submitting = false;
  public form: UntypedFormGroup;
  public items: Array<MenuItem> = [];

  constructor() { }

  onEdit(): void {
    this.startEdit();
  }

  onCancel(): void {
    this.stopEdit();
  }

  onSubmit(): void {}

  onDelete(): void {}

  protected startEdit(): void {
    this.inEdit = true;
  }

  protected stopEdit(): void {
    this.inEdit = false;
  }

}
